import { render, staticRenderFns } from "./CategoryItemsList.vue?vue&type=template&id=4e5957a6&scoped=true&"
import script from "./CategoryItemsList.vue?vue&type=script&lang=js&"
export * from "./CategoryItemsList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItemsList.vue?vue&type=style&index=0&id=4e5957a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5957a6",
  null
  
)

export default component.exports